<div class="dropdown">
  <div
    class="dropdown-togglable"
    (click)="toggled = !toggled"
    (keydown.space)="toggled = !toggled"
    (keydown.enter)="toggled = !toggled"
    tabindex="0"
    >
    <div class="dropdown-header">
      {{ 'dictionary.' + dropdownInput.translateKey + 'Header' | translate }}
    </div>

    <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
  </div>

  @if (toggled) {
    <div class="dropdown-description">
      <hr class="divider">
      <p [innerHTML]="'dictionary.' + dropdownInput.translateKey + 'Description' | translate | htmlFormat"></p>
      @if (dropdownInput.link) {
        <div class="link-container">
          {{ 'dictionary.link.prefix' | translate }} <a href="{{ dropdownInput.link }}">{{ 'dictionary.link.clickable' | translate }}</a>.
        </div>
      }
    </div>
  }
</div>